

  const selectors$tc = {
    stackedWrapper: ".product__wrapper--stacked",
    thumbWrapper: "[data-thumb-wrapper]",
    announcementBar: "#shopify-section-announcement",
    header: "#shopify-section-header",
    imagesContainer: ".product-images__container",
    stackedThumbs: ".product__thumbs.product__thumbs--stacked",
    productSlideHidden: ".product__slide:not(.hidden)",
    thumbLinkImage: "thumb__link__image",
    thumbLink: "thumb__link",
    thumbLinkImageModifier: "thumb__link--image",
    thumb: "thumb",
  };

  const THUMB_CAROUSEL_CONFIG = {
    scrollOffset: 8,
  };

  if (!customElements.get('product-gallery-manager')) {
    class ProductGalleryManager extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.container = this.closest('[data-section-type="product"]') || this.closest('[data-section-type="api-product-upsell"]');
        this.isQuickAdd = this.container?.hasAttribute('data-product-upsell-ajax') ? true : false;

        this.productId = this.container.querySelector(
          'input[name="productId"]'
        ).value;

        this._initThumbCarousel();

        this._addEventListeners()

      }

      _addEventListeners() {

        const optionsRadios = this.container.querySelectorAll('.product__selectors input[type="radio"]:not(.optional-product__radio)');


        optionsRadios.forEach((radio) => {
          radio.addEventListener("change", this._onVariantSelected.bind(this));
        });
      }

      _onVariantSelected(event) {

        const selected = event.target;
        if (selected.getAttribute("name") == "options[Color]") {
          console.log('  Color option changed.');
          let value = selected.value.toLowerCase().replaceAll(" ", "-");
          console.log("🚀 ~ ProductThumbCarousel ~ _onVariantSelected ~ value:", value)

          // let elem = document.querySelector('.thumbs-holder');
          // showVariantImages(elem, value, productId);
          const windowWidth =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;
          const isMobile = windowWidth < theme.sizes.small;
          console.log("🚀 ~ ProductGalleryManager ~ _onVariantSelected ~ isMobile:", isMobile)

          if (isMobile && this.container.getAttribute("data-tall-layout") !== "true") {
            let thumbsHolder = this.container.querySelector("[data-product-thumbs]");
            if (thumbsHolder) {
              let elem = document.querySelector(".thumbs-holder");
              console.log("🚀 ~ ProductGalleryManager ~ _onVariantSelected ~ mobile elem:", elem)
              this._showVariantImages(elem, value);
            }
          } else {
            console.log("🚀 ~ ProductGalleryManager ~ _onVariantSelected ~ desktop container:", this)
            this._showVariantImages(this, value);
          }
        }

      }

      _waitForElement(selector) {
        console.log("🚀 ~ ProductGalleryManager ~ _waitForElement ~ selector:", selector)
        return new Promise(resolve => {
          if (document.querySelector(selector)) {
            console.log("🚀 ~ ProductGalleryManager ~ _waitForElement ~ found immediately:", document.querySelector(selector))
            return resolve(document.querySelector(selector));
          }

          const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
              console.log("🚀 ~ ProductGalleryManager ~ _waitForElement ~ found via MutationObserver:", document.querySelector(selector))
              resolve(document.querySelector(selector));
              observer.disconnect();
            }
          });

          observer.observe(document.body, {
            childList: true,
            subtree: true
          });
        });
      };


      _initThumbCarousel() {

        console.log('[ProductGalleryManager] _initThumbCarousel');

        const windowWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
        console.log("🚀 ~ ProductGalleryManager ~ _initThumbCarousel ~ windowWidth:", windowWidth)
        const isMobile = windowWidth < (window.theme?.sizes?.small || 768);
        let checked = this.container.querySelector(
          'input[name="options[Color]"]:checked',
        );

        console.log('  _initThumbCarousel: checked color input:', checked);

        if (checked) {
          checked = checked.value.toLowerCase().replaceAll(" ", "-");
          console.log("🚀 ~ ProductGalleryManager ~ _initThumbCarousel ~ checked value:", checked)
        }

        const groupId = this.container.querySelector(
          '.product-form input[name="productId"]'
        )?.value;

         if (!groupId) {
          return;
        }

        if(this.isQuickAdd) {
            this._showVariantImages(this, checked, groupId);
        }

        if (this.container.getAttribute("data-tall-layout") !== "true" || isMobile) {
          let thumbsHolder = this.querySelector("[data-product-thumbs]");
          if (thumbsHolder) {
            this._waitForElement(".thumbs-holder").then((elem) => {
              this._showVariantImages(elem, checked, groupId);
            });
          }
          else {
            this._showVariantImages(this, checked, groupId);
          }
        } else {
          this._showVariantImages(this, checked, groupId);
        }
      }

      _showVariantImages(elem, value) {
        const productId = this.productId;

        if (this.container.classList.contains("product--no-color") !== true) {
          let thumbs = elem.querySelectorAll(".thumb");

          if (thumbs) {
            thumbs.forEach((thumb) => {
              thumb.classList.add("hidden");
              var link = thumb.querySelector(".thumb__link");
              var alt = thumb.querySelector("img").getAttribute("alt");
              var groupId = link.dataset.groupId;

              if (alt) {
                alt = alt.toLowerCase().replaceAll(" ", "-");
                if (alt.includes(value) && groupId == productId) {

                  thumb.classList.remove("hidden");
                }
              }
            });
            const firstVisibleThumbLink = elem.querySelector(".thumb:not(.hidden) .thumb__link");

            firstVisibleThumbLink?.click();
          }

          // hide all the images when layout is stacked
          let slides = elem.querySelectorAll(".product__slide");

          if (slides) {
            slides.forEach((slide) => {
              slide.classList.add("hidden");
              var option = slide.dataset.option;
              var groupId = slide.dataset.groupId;

              if (option) {
                option = option.toLowerCase().replaceAll(" ", "-");
                if (option.includes(value) && groupId == productId) {

                  slide.classList.remove("hidden");
                  slide.classList.remove("product__slide--non-critical");
                }
              }
            });
          }
        } else {

          elem.querySelectorAll(".product__slide").forEach((slide) => {
            slide.classList.remove("hidden");
            slide.classList.remove("product__slide--non-critical");
          });
        }

        this._buildDesktopThumbs(elem);

      }

      _buildDesktopThumbs(elem) {

        // This works only in stacked mode.
        if (!document.querySelector(selectors$tc.stackedWrapper)) {
          return;
        }

        const photosHolder = this.querySelector(selectors$tc.thumbWrapper);

        if (!photosHolder) {
          console.warn('Thumb carousel: "photosHolder" not found.');
          return;
        }

        const thumbsHolder = this._getOrCreateThumbsHolder(photosHolder);
        
        thumbsHolder.innerHTML = ''; // Clear existing thumbs to prevent duplication

        const slides = elem.querySelectorAll(selectors$tc.productSlideHidden);
        
        slides.forEach(slide => {
          this._createAndAppendThumbnail(slide, thumbsHolder);
        });
      }

      _getOrCreateThumbsHolder(photosHolder) {
        let thumbsHolder = document.querySelector(selectors$tc.stackedThumbs);
        
        if (!thumbsHolder) {
          
          thumbsHolder = document.createElement("div");
          thumbsHolder.classList.add("product__thumbs", "product__thumbs--stacked");
          photosHolder.insertBefore(thumbsHolder, photosHolder.firstChild);
        }
        return thumbsHolder;
      }

      _createAndAppendThumbnail(slide, thumbsHolder) {
        
        const thumbSrc = slide.dataset.thumb;
        
        if (!thumbSrc) {
          
          return
        }

        const wrapper = document.createElement("div");
        wrapper.classList.add(selectors$tc.thumb);
        wrapper.setAttribute("data-group-id", slide.dataset.groupId || "");

        const link = document.createElement("a");
        link.classList.add(selectors$tc.thumbLink, selectors$tc.thumbLinkImageModifier);
        link.href = "#"; // Use a valid href for accessibility
        link.addEventListener("click", (evt) => {
          evt.preventDefault();
          this._scrollToSlide(slide);
        });

        const image = document.createElement("img");
        image.src = thumbSrc;
        image.loading = "lazy";
        image.classList.add(selectors$tc.thumbLinkImage);

        link.appendChild(image);
        wrapper.appendChild(link);
        thumbsHolder.appendChild(wrapper);
      }

      _scrollToSlide(slide) {
        
        const announcementHeight = document.querySelector(selectors$tc.announcementBar)?.clientHeight || 0;
        const headerHeight = document.querySelector(selectors$tc.header)?.clientHeight || 0;
        const scroller = document.querySelector(selectors$tc.imagesContainer);

        if (!scroller) {
          console.error("Scroller element not found:", selectors$tc.imagesContainer);
          return;
        }

        const top = slide.offsetTop + (announcementHeight + headerHeight - THUMB_CAROUSEL_CONFIG.scrollOffset);
        
        scroller.scrollTo({
          top: top,
          left: 0,
          behavior: "smooth",
        });
      }
    }

    customElements.define('product-gallery-manager', ProductGalleryManager);
  }
